import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  button: {
    borderRadius: Theme.tileBorderRadius,
    flexDirection: 'row',
    height: Theme.px(210),
    justifyContent: 'center',
    width: Theme.px(252),
  },
  container: {
    alignSelf: 'center',
    borderRadius: Theme.tileBorderRadius,
    height: Theme.px(198),
    justifyContent: 'center',
    width: Theme.px(240),
  },
  inactive: {
    backgroundColor: Theme.rhinoGrey,
  },
});
